import colors from './colors'
import typography from './typography'

export default {
    colors,
    typography
}
